module.exports = __webpack_public_path__ + "img/item-frame.b239d725.png";